// src/hooks/useStudents.js
// Fetches and caches student list from Firestore

import { useState, useEffect, useCallback } from "react";
import { getAllStudents, saveStudentProfile } from "../firebase/database";

export function useStudents() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getAllStudents();
      setStudents(data.sort((a, b) => (a.roll || "").localeCompare(b.roll || "")));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addStudent = useCallback(async (studentData) => {
    await saveStudentProfile(studentData.id, studentData);
    await load();
  }, [load]);

  const getById = useCallback((id) => students.find(s => s.id === id), [students]);

  const byBatch = useCallback((batch) => students.filter(s => s.batch === batch), [students]);

  const batches = [...new Set(students.map(s => s.batch).filter(Boolean))].sort();

  return { students, loading, error, reload: load, addStudent, getById, byBatch, batches };
}
